import React from 'react'
import PropTypes from 'prop-types'
import { GENERAL_EVENTS, SPORT_EVENTS, EVENTS } from 'constants/appConstants'
import GenericCard from './GenericCard'
import EventCard from './EventCard'

const ContentTypeCard = ({ item, itemHeight, contentType, featured, handleStatus }) => {
  return (
    <>
      {contentType !== GENERAL_EVENTS && contentType !== SPORT_EVENTS && contentType !== EVENTS ? (
        <GenericCard
          item={item}
          itemHeight={itemHeight}
          contentType={contentType}
          featured={featured}
          handleStatus={handleStatus}
        />
      ) : (
        <EventCard item={item} itemHeight={itemHeight} contentType={contentType} handleStatus={handleStatus} />
      )}
    </>
  )
}

ContentTypeCard.defaultProps = {
  itemHeight: '',
  featured: false,
  handleStatus: () => {},
}

ContentTypeCard.propTypes = {
  item: PropTypes.object.isRequired,
  itemHeight: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  featured: PropTypes.bool,
  handleStatus: PropTypes.func,
}

export default ContentTypeCard
